// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3rDV6","filesListContainer":"PosDisputesFiles_filesListContainer__DnrDZ","filesButton":"PosDisputesFiles_filesButton__1fky9"};